import { Component } from '@angular/core';

@Component({
    standalone: true,
    selector: 'app-footer',
    template: `<div class="layout-footer">
        <span>AJT.NSQB by</span>
        <span class="team-vision" role="img" aria-label="Team VISION">
            <svg class="team-vision-mark" viewBox="0 0 100 78" aria-hidden="true" focusable="false">
                <path fill="currentColor" fill-rule="evenodd" d="M0 0h28l12 20Q27 23 24 30Q50 53 74 30Q68 23 60 20L72 0h28L50 78Z" />
                <circle cx="50" cy="30" r="8.5" fill="currentColor" />
            </svg>
            <span class="team-vision-wordmark" aria-hidden="true">
                <span class="team-vision-team">Team</span>
                <span class="team-vision-name">VISION</span>
            </span>
        </span>
    </div>`,
    styles: `
        .team-vision {
            display: inline-flex;
            align-items: center;
            gap: 0.4rem;
            color: var(--text-color);
            flex-shrink: 0;
        }

        .team-vision-mark {
            width: 2.6rem;
            height: 2.1rem;
        }

        .team-vision-wordmark {
            display: flex;
            flex-direction: column;
            font-family: Arial, Helvetica, sans-serif;
            line-height: 1;
        }

        .team-vision-team {
            font-size: 0.75rem;
            font-weight: 600;
        }

        .team-vision-name {
            font-size: 1.3rem;
            font-weight: 800;
            letter-spacing: 0.025em;
        }
    `
})
export class AppFooter {}
